import React, { StrictMode } from 'react';

import Application from 'components/core/Application.component';
import ErrorBoundary from 'components/core/ErrorBoundary.component';
import Providers from 'components/core/Providers.component';
import FLAG from 'config/flag.singleton';
import SENTRY from 'config/sentry.singleton';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const USE_STRICT_MODE = fromAnyToBool(FLAG.reactStrictMode);

const Root = () => {
  const renderedChildren = (
    <SENTRY.ErrorBoundary>
      <ErrorBoundary strat="console" tag="Root">
        <Providers>
          <Application />
        </Providers>
      </ErrorBoundary>
    </SENTRY.ErrorBoundary>
  );

  return USE_STRICT_MODE ? <StrictMode>{renderedChildren}</StrictMode> : renderedChildren;
};

export default Root;
